import { call, put } from 'redux-saga/effects';
import { getRepairResourcesFailureAction, getRepairResourcesSuccessAction } from '../actions';
import { getFormattedRepairResources, RepairResourceLookupService } from '../services';
export function* getRepairResourcesSaga(action, 
/*istanbul ignore next*/
resourceLookupService = RepairResourceLookupService.getInstance()) {
    try {
        const { repairResourceLookupPayload, isResourceRepairOrchestratorUrl } = action.payload;
        const response = yield call({
            context: resourceLookupService,
            fn: resourceLookupService.getRepairResources
        }, repairResourceLookupPayload, isResourceRepairOrchestratorUrl);
        yield put(getRepairResourcesSuccessAction(getFormattedRepairResources(response)));
    }
    catch (ex) {
        yield put(getRepairResourcesFailureAction(ex.toString()));
    }
}
//# sourceMappingURL=getRepairResourcesSaga.js.map